<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>机器人偷配置{{ formData.id > 0 ? '编辑' : '新增' }}</span>
        </div>
        <el-form ref="formData" :model="formData" label-width="120px">
          <el-form-item label="偷取类型">
            <el-select v-model.number="formData.steal_type" placeholder="请选择">
              <el-option
                v-for="item in stealType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData.steal_type===2" label="系数区间(百分比)">
            <el-input v-model.number="formData.y_ratios.start" placeholder="最小值" class="inputW2" />
            -
            <el-input v-model.number="formData.y_ratios.end" placeholder="最大值" class="inputW2" />
          </el-form-item>
          <el-form-item v-else label="偷取比例(百分比)">
            <el-input v-model.trim.number="formData.ratios" class="inputW" />
          </el-form-item>
          <el-form-item label="偷取方式">
            <el-select v-model.number="formData.steal_method" placeholder="请选择">
              <el-option
                v-for="item in stealMethod"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData.steal_method===2" label="偷取日期">
            <el-date-picker v-model="formData.date.start" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="开始时间" />
            <span style="padding: 0 5px">-</span>
            <el-date-picker v-model="formData.date.end" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="结束时间" />
          </el-form-item>
          <el-form-item v-else label="用户UID">
            <el-input v-model.number="formData.uid" class="inputW" />
          </el-form-item>
          <el-form-item v-if="formData.steal_method===2" label="排名">
            <el-input v-model.number="formData.rank" class="inputW" />
            <span class="tips-span"><i class="el-icon-warning-outline" />对金币总排名前N个玩家进行偷取</span>
          </el-form-item>
          <el-form-item label="冷却时间(秒)">
            <el-input v-model.number="formData.cool_off" class="inputW" />
          </el-form-item>
          <el-form-item label="冷却随机值(秒)">
            <el-input v-model.number="formData.rand_num.start" class="inputW2" />
            -
            <el-input v-model.number="formData.rand_num.end" class="inputW2" />
          </el-form-item>
          <el-form-item :label="formData.steal_method===1 ? '偷取次数' :'偷取次数范围'">
            <el-input v-model.number="formData.count.start" class="inputW2" />
            -
            <el-input v-model.number="formData.count.end" :disabled="formData.steal_method===1" class="inputW2" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model.number="formData.status" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRobotStealList, updateRobotStealtCfg } from '@/api/config/robot-steal'

export default {
  name: 'RobotStealEdit',
  data() {
    return {
      stealType: [{ label: '按比例', value: 1 }, { label: '固定值', value: 2 }],
      stealMethod: [{ label: '手动偷', value: 1 }, { label: '自动偷', value: 2 }],
      formData:
        {
          id: 0,
          uid: '',
          steal_type: 1,
          steal_method: 1,
          ratios: 0,
          cool_off: 0,
          date: {
            start: '',
            end: ''
          },
          y_ratios: {
            start: 0,
            end: 0
          },
          count: {
            start: 0,
            end: 0
          },
          rank: 0,
          rand_num: { start: 0, end: 0 },
          status: 0
        },
      options: [
        { label: '未运行', value: 0, disabled: false },
        { label: '运行中', value: 1, disabled: false },
        { label: '手动停止', value: 2, disabled: false }
        // { label: '运行完成', value: 3 }
      ]
    }
  },
  created() {
    const id = this.$route.query.id
    if (id > 0) {
      this.getTables(id)
    }
  },
  methods: {
    getTables(id) {
      getRobotStealList({ id: id }).then(res => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.formData = res.data.list[0]
            if (this.formData.status === 1) {
              this.options[0].disabled = true
            }
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const _data = this.formData
          if (_data.steal_method === 1) {
            if (!_data.uid) {
              this.msgError('uid不能为空')
              return
            }
            if (!_data.count.start) {
              this.msgError('偷取次数不能是0')
              return
            }
          } else {
            if (!_data.date.start) {
              this.msgError('偷取开始日期不能为空')
              return
            }
            if (!_data.date.end) {
              this.msgError('偷取结束日期不能为空')
              return
            }
            if (_data.date.start > _data.date.end) {
              this.msgError('偷取开始日期不能大于结束日期')
              return
            }

            if (_data.rank <= 0) {
              this.msgError('偷取排名不能小于0')
              return
            }

            if (!_data.count.start || !_data.count.end) {
              this.msgError('偷取次数范围不能是0,disabled:0')
              return
            }

            if (_data.count.start > _data.count.end) {
              this.msgError('偷取次数开始值不能大于结束值')
              return
            }
          }

          if (!_data.cool_off) {
            this.msgError('冷却时间不能为空')
            return
          }
          if (_data.steal_type === 1 && !_data.ratios) {
            this.msgError('偷取比例不能为0')
            return
          }
          if (_data.steal_type === 2) {
            if (!_data.y_ratios.start || !_data.y_ratios.end) {
              this.msgError('系数值不能为0')
              return
            }

            if (_data.y_ratios.start > _data.y_ratios.end) {
              this.msgError('系数开始值不能大于系数结束值')
              return
            }
          }
          if (_data.rand_num.start > _data.rand_num.end) {
            this.msgError('随机开始值不能大于结束值')
            return
          }
          const data = JSON.stringify(_data)
          updateRobotStealtCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$router.push({ path: '/config/robot-steal/index' })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.inputW{
  width: 400px;
}
.inputW2{
  width: 180px;
}
.tips-span{
  margin-left: 10px;
}
</style>
